var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8338 14.9893C11.8691 14.9893 9.49975 14.9923 9.49975 14.9923V12.6426H15.4225C15.835 15.4857 14.5907 19.7504 9.49975 19.7504C6.0938 19.7504 3.33275 17.0941 3.33275 13.8175C3.33275 10.5408 6.0938 7.88452 9.49975 7.88452C11.0979 7.88452 12.5541 8.46936 13.6497 9.42873C12.8007 10.2001 12.5285 10.4941 12.2972 10.7439C12.1769 10.8739 12.0677 10.9919 11.8941 11.1589C11.2604 10.6547 10.5695 10.2929 9.49975 10.2929C7.47643 10.2929 5.89725 11.8709 5.89725 13.8175C5.89725 15.764 7.47643 17.342 9.49975 17.342C11.4991 17.342 12.3114 16.5125 12.8338 14.9893ZM20.6138 10.7042V12.7601H22.7509V14.2287H20.6138V16.3434H19.0873V14.2287H16.8892V12.7601H19.0873V10.7042H20.6138Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlus);
export default __webpack_public_path__ + "static/media/google_plus.950ddf4ad7e27509f79695fdad382bb7.svg";
export { ForwardRef as ReactComponent };